export default __webpack_public_path__ + "static/media/192.d42f76fe.png";